import React, { useState } from 'react'
import styles from './customPopup.module.css'

export default function CustomPopup({
    isShow,
    handelClosePopup,
    popupTitle,
    popupMessage,
}) {
    const closePopup = () => {
        handelClosePopup()
    }

    return (
        <>
            {/* Popup */}
            {isShow && (
                <div className={styles.overlay}>
                    <div className={styles.popup}>
                        {/* <button
                            className={styles.closeBtn}
                            onClick={() => closePopup}
                        >
                            ✖
                        </button> */}

                        <h3>{popupTitle}</h3>
                        <p>{popupMessage}</p>
                    </div>
                </div>
            )}
        </>
    )
}
